import React from 'react';
const AdventureGuide: React.FC = () => (
  <div className="min-h-screen bg-white py-12" dir="ltr">
    <div className="max-w-3xl mx-auto bg-teal-50 rounded-xl shadow-lg p-8">
      <h1 className="text-3xl font-bold text-teal-900 mb-6">Adventure & Nature in Iran</h1>
      <p className="text-lg text-gray-700 mb-4">Find the best nature spots, book tours, and learn essential adventure vocabulary.</p>
      {/* Add more content here */}
    </div>
  </div>
);
export default AdventureGuide; 